import * as React from 'react';
import Row from 'reactstrap/lib/Row';
import { Col } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import { IArrestBinderList } from 'src/share/types/match';

export interface IArrestBinderListProps {
  suspectId: string;
  arrestBinderList: IArrestBinderList[];
}

const ArrestBinderList = (props: IArrestBinderListProps) => (
  <Row key={`arrest-binder-list-${props.suspectId}`}>
    <ul className="binder-list">
      <Col md={12} className="stats-info binder-list-title arrest-container">
        <h2>Arrest Binder List</h2>
      </Col>
      <Row className="biometrica-binder-list" >
        {props.arrestBinderList.map(arrest =>
          <Col md={props.arrestBinderList.length > 1 ? 6 : 12} className="stats-info arrest-binder-details" key={arrest.id}>
            <li><p><Label>Arrest date:</Label>{arrest.arrestDate || 'Unknown'}</p></li>
            <p><Label>Address:</Label>{arrest.address || 'Unknown'}</p>
            <p><Label>Arrested age:</Label>{arrest.age || 'Unknown'}</p>
            <p><Label>Arresting agency:</Label>{arrest.arrestingAgency ? <a href={`https://www.google.com/search?q=${arrest.arrestingAgency.split(' ').join('+')}&num=1`}>{arrest.arrestingAgency}</a> : 'Unknown'}</p>
          </Col>
        )}
      </Row>
    </ul>
  </Row>
);

export default ArrestBinderList;